import { ChangeDetectorRef, Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApiService } from '@shared/services/api.service';
import { AuthService } from '@shared/services/auth.service';
import { LocaleService } from '@shared/services/locale.service';
import { ScrollService } from '@shared/services/scroll.service';
import { ViewportService } from '@shared/services/viewport.service';
import { AddViewRepliesComponent } from '../add-view-replies/add-view-replies.component';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { User } from '@core/models';

@Component({
	selector: 'app-view-comments',
	templateUrl: './view-comments.component.html',
	styleUrls: ['./view-comments.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ViewCommentsComponent implements OnInit {
	constructor(
		@Inject(MAT_DIALOG_DATA) public data,
		private api: ApiService,
		private auth: AuthService,
		public locale: LocaleService,
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<ViewCommentsComponent>,
		private router: Router,
		public viewport: ViewportService,
		private cdf: ChangeDetectorRef
	) {}

	toggleButton: boolean = false;
	loading: boolean = false;
	commentList: Object;
	reply: string;
	visible: boolean = false;
	tempstatus: any = 1;
	visibleye: boolean = false;
	box: boolean = false;
	user: User = this.auth.user();
	commentListArr: any = [];
	tempListArr: any = [];
	page: any = 1;
	nextPage: any;
	ads: any[];
	load: boolean = false;
	showLoad: boolean = false;
	comment: string;

	ngOnInit(): void {
		this.showAllComments();
	}

	toggle(id: any, status: any) {
		if (status === '1') {
			status = 2;
		} else {
			status = 1;
		}

		const formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		formData.append('commentID', id);
		formData.append('userID', this.user['userID']);
		formData.append('adID', this.data['adID']);
		formData.append('status', status);
		this.loading = true;
		this.api.hideComment(formData).subscribe((res) => {
			if (res.status === '1') {
				this.commentListArr = [];
				this.page = 1;
				this.showAllComments();
				this.loading = false;
			}
		});
	}

	addComment(comment) {
		if (this.user) {
			const formData: FormData = new FormData();
			formData.append('lang', this.locale.lang);
			formData.append('userID', this.user['userID']);
			formData.append('adID', this.data['adID']);
			formData.append('comment', comment);
			// formData.append('commentID', this.commentID);

			this.api.addComment(formData).subscribe((res) => {
				if (res.status === '1') {
					this.commentListArr = [];
					this.comment = null;
					this.page = 1;
					this.showAllComments();
				}
			});
		} else {
			this.router.navigate(['/login'], {
				queryParams: {
					redirect: 'ad/',
					id: this.data['adID'],
				},
			});

			this.dialogRef.close();
		}
	}

	showAllComments() {
		if (this.user) {
			const commentFormData: FormData = new FormData();
			commentFormData.append('adID', this.data['adID']);
			commentFormData.append('lang', this.locale.lang);
			commentFormData.append('page', this.page);
			commentFormData.append('commentLimit', '');
			commentFormData.append('ownerUserID', this.data['userAd']);
			commentFormData.append('userID', this.user['userID']);
			this.api.comments(commentFormData).subscribe((res) => {
				this.tempListArr = res['response']['data'];

				for (let i = 0; i < res['response']['data']['length']; i++) {
					res['response']['data'][i]['createdAt'] = moment.unix(res['response']['data'][i]['createdAt']).fromNow(true);
				}

				this.nextPage = res['response']['pages'];

				if (this.page >= this.nextPage) {
					this.load = false;
				} else {
					this.load = true;
				}

				this.commentListArr = [...this.commentListArr, ...this.tempListArr];
				this.showLoad = false;
				this.cdf.detectChanges();

				this.box = true;
			});
		} else {
			const commentFormData: FormData = new FormData();
			commentFormData.append('adID', this.data['adID']);
			commentFormData.append('lang', this.locale.lang);
			commentFormData.append('page', this.page);
			commentFormData.append('commentLimit', '');
			commentFormData.append('ownerUserID', this.data['userAd']);

			this.api.comments(commentFormData).subscribe((res) => {
				this.tempListArr = res['response']['data'];

				for (let i = 0; i < res['response']['data']['length']; i++) {
					res['response']['data'][i]['createdAt'] = moment.unix(res['response']['data'][i]['createdAt']).fromNow(true);
				}

				this.nextPage = res['response']['pages'];

				if (this.page >= this.nextPage) {
					this.load = false;
				} else {
					this.load = true;
				}

				this.commentListArr = [...this.commentListArr, ...this.tempListArr];
				this.showLoad = false;
				this.cdf.detectChanges();

				this.box = true;
			});
		}
	}

	LoadMore() {
		this.showLoad = true;
		this.page++;

		if (this.page <= this.nextPage) {
			this.showAllComments();
		}
	}

	close() {
		this.dialogRef.close();
	}

	openReplyDialog(id) {
		const Replydialog = this.dialog.open(AddViewRepliesComponent, {
			maxWidth: '700px',
			width: '96%',
			maxHeight: '700px',
			data: {
				commentID: id,
				adID: this.data['adID'],
				// userID: this.user['userID'],
				lang: this.locale.lang,
				userAd: this.data['userAd'],
				vip: this.data['vip'],
				premium: this.data['premium'],
			},
		});

		Replydialog.afterClosed().subscribe((data) => {
			this.cdf.detectChanges();
			// this.showAllComments();
		});
	}
	getToggle(comment) {
		this.toggleButton =
			(this.user['userID'] === this.data['userAd'] && (this.data['vip'] === '1' || this.data['premium'] === '1')) ||
			comment['userID'] === this.user['userID'];

		return this.toggleButton;
	}
}
